
const seo = {
  /* computed: {
    seo: {
      get () {
        if (typeof this.pageApiData === 'undefined') return

        return this.pageApiData.seo
      }
    }
  },
  methods: {
    $_setSeoHtml ({ title, meta }) {
      document.title = title
      _.forEach(meta, this.$_setMeta)
    },
    $_setMeta (tag) {
      const existingTag = document.querySelector(`meta[name="${tag.name}"]`)

      const workingTag = existingTag === null
        ? document.createElement('meta')
        : existingTag

      _.forEach(_.keys(tag), attribute => {
        workingTag.setAttribute(attribute, tag[attribute])
      })

      if (existingTag === null) document.head.appendChild(workingTag)
    }
  },
  watch: {
    seo: {
      handler (data) {
        if (typeof data !== 'undefined') this.$_setSeoHtml(data)
      },
      immediate: true,
      deep: true
    }
  },
*/
  metaInfo () {
    if (this.seo && this.seo !== null) {
      return {
        title: this.seo.title,
        meta: [
          { vmid: 'description', name: 'description', content: this.seo.description },
          { vmid: 'og:description', property: 'og:description', content: this.seo.description },
          { vmid: 'og:title', property: 'og:title', content: this.seo.title },
          { vmid: 'og:image', property: 'og:title', content: this.seo.image ? this.seo.image.url : '' }
        ]
      }
    }
    return {
      title: this.pageApiData.seo.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageApiData.seo.meta[0].content },
        { vmid: 'og:description', property: 'og:description', content: this.pageApiData.seo.meta[0].content },
        { vmid: 'og:title', property: 'og:title', content: this.pageApiData.seo.title }
      ]
    }
  }
}

export default seo
